(function () {
  'use strict';

  function factory() {
    'ngInject';

    var spectrumMin = 2200;
    var spectrumMax = 6500;
    var warmRange = 2800;
    var coolRange = 1500;
    var neutral = 5000;

    return {
      convert: convert,
      min: spectrumMin,
      max: spectrumMax,
      warmRange: warmRange,
      coolRange: coolRange,
      neutral: neutral,
    };

    function convert(temperature) {
      // Start value from zero
      var opacity = temperature - spectrumMin;
      if (temperature > neutral) {
        // Normalize to 0-1
        opacity = (opacity - warmRange) / coolRange;
        return {
          warm: 0,
          cool: opacity,
        };
      }
      // Normalize to 0-1
      opacity /= warmRange;
      // Invert value since we are actually going from
      // warm to neutral, not neutral to warm.
      opacity = 1 - opacity;
      return {
        warm: opacity,
        cool: 0,
      };
    }
  }

  angular
    .module('hq.tools.lighting')
    .factory('hqTLightingKelvins', factory);
}());
